// extracted by mini-css-extract-plugin
module.exports = {"floatLabel":"FloatedLabelInput_floatLabel__1S5Uu","has-top-label":"FloatedLabelInput_has-top-label__38cgL"};